<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <tools
            :excel="
              'payment/wallet-transactions/export/excel' +
                createQueryString(filters)
            "
          />
          <bita-form ref="filterForm">
            <div slot="body">
              <div class="row">
                <bita-input
                  type="text"
                  name="name"
                  label="جستجو"
                  validation-container-class="col-lg-3"
                  input-class="form-control"
                  v-model.lazy="filters.search"
                  @keyup.enter="loadData()"
                />
                <bita-datepicker
                  type="datetime"
                  id="paymentat"
                  validation-container-class="col-lg-2"
                  name="start_at"
                  rules=""
                  label="شروع تاریخ ایجاد"
                  inputClass="form-control"
                  v-model="filters.start_at"
                  format="YYYY-MM-DD HH:mm:ss"
                  display-format="jYYYY/jMM/jDD HH:mm:ss"
                />
                <bita-datepicker
                  type="datetime"
                  id="paymentat"
                  validation-container-class="col-lg-2"
                  name="end_at"
                  rules=""
                  label="پایان تاریخ ایجاد"
                  inputClass="form-control"
                  v-model="filters.end_at"
                  format="YYYY-MM-DD HH:mm:ss"
                  display-format="jYYYY/jMM/jDD HH:mm:ss"
                />
                <div class="col-lg-4">
                  <a class="margin-top btn btn-success" @click="loadData()">
                    جستجو
                  </a>
                  <a
                    class="margin-top margin-right btn btn-warning"
                    @click="resetFilters()"
                  >
                    پاک سازی
                  </a>
                </div>
              </div>
            </div>
          </bita-form>
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
            :page-size="pageSize"
            :current-page="currentPage"
            :has-row-number="true"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>
<script>
import { walletTransactionApi } from "@/api/apiManagement";
import Tools from "../../../components/Tools.vue";
export default {
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "لیست تراکنش های کیف پول کاربران",
          link: "/shop/transactions",
        },
      ],
      isLoadingGrid: false,
      isLoadingModal: false,
      pageSize: 30,
      currentPage: 1,
      filters: {},
    };
  },
  components: {
    Tools,
  },
  computed: {
    gridColumns() {
      return [
        {
          field: "type_name",
          title: "عنوان",
          template: (e) => (e.type_name ? e.type_name : "-"),
        },
        {
          field: "user",
          title: "کاربر",
          template: (e) => {
            return e.user ? e.user.full_name : "-";
          },
        },
        {
          field: "price",
          title: this.$currencyLabel("مبلغ"),
          template: (e) => {
            return (
              `<span class="${
                e.transaction_type == 1 ? "text-success" : "text-danger"
              }">` +
              this.$thousandSeprator(this.$round(e.price)) +
              `<span>`
            );
          },
        },
        {
          field: "transaction_id",
          title: this.$currencyLabel("مجموع"),
          template: (e) =>
            e.cumulative_sum
              ? this.$thousandSeprator(this.$round(e.cumulative_sum))
              : "-",
        },
        {
          field: "description",
          title: "درگاه بانکی",
          template: (e) => (e.transaction ? e.transaction.paymethod_text : "-"),
        },
        {
          field: "description",
          title: "توضیحات",
          template: (e) => (e.description ? e.description : "-"),
        },
        {
          field: "created_at",
          title: "تاریخ",
          template: (e) => (e.created_at ? e.created_at : "-"),
        },
      ];
    },
  },
  methods: {
    createQueryString(_query, _prefix = "?") {
      return _prefix + new URLSearchParams(_query);
    },
    readData(e) {
      this.isLoadingGrid = true;
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      walletTransactionApi
        .getTransactions({
          page_size: this.pageSize,
          page: this.currentPage,
          ...this.filters,
        })
        .then(({ data }) => {
          e.success(data);
        })
        .catch((res) => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    resetFilters() {
      this.filters = {};
    },
  },
};
</script>
